<template>
  <div class="search" @touchmove.prevent @mousewheel.prevent>
    <!-- 输入框 -->
    <div class="searchBox">
      <div class="content">
        <div class="applyBtn flex f15" >
          <!-- <div class="btnbar" :style="{'background':info.setting.color}"></div> -->
          <div class="btndiv flex">搜 索</div>
          <!-- <div class="btnbar" :style="{'background':info.setting.color}"></div> -->
        </div>
        <div class="input">
          <van-search clearable @clear='clear()' v-model="value" placeholder="请输入选手编号或名称" />
        </div>
        <div class="searchBtn">
          <van-button @click="gotoVote()" type="primary">搜索</van-button>
        </div>
      </div>
    </div>
    <!-- 关闭按钮 -->
    <div class="close" >
      <van-icon @click='close()' name="close"  />
    </div>
  </div>
</template>

<script>
  import searchMixin from "@/mixins/search.js"
  export default {
    mixins:[searchMixin],
    data(){
      return{
        info:JSON.parse(sessionStorage.getItem('info')),
      }
    }
  }
</script>

<style lang="less" scoped>
.search{
  width: 10rem;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  max-width: 10rem;
  margin: auto;
  z-index: 999999;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background: rgba(0, 0, 0, 0.5);
  .searchBox{
    width: 9.2rem;
    height: 6.6666667rem;
    box-sizing: border-box;
    position: relative;
    .content{
      width: 92%;
      background: #2e221a;
      position: absolute;
      bottom: .2666667rem;
      left: 0;
      right: 0;
      margin: auto;
      border-radius: 0.08rem;
      .input{
        margin: .8rem 0 .8rem;
        .van-search{
          background: transparent;
          // border: 1px solid 
          border: 0.02rem solid #c99f73;
          border-radius: 3px;
          padding: 0;
          margin: 0 .2666667rem;
          height: 1.067rem;
          .van-search__content{
            background-color: transparent;
            .van-cell{
              color: #f4d280;
            }
           /deep/.van-field__control{
              color: #f4d280;
            }
          }
        }
      }
      .searchBtn{
        height: 1.067rem;
        width: 100%;
        box-sizing: border-box;
        .van-button{
          width: 100%;
          height: 100%;
          background: #f4d280;
          border: none;
          color: #a67a0f;
          font-weight: bold;
          font-size: 16px;
        }
      }
    }
  }
  div.close{
    margin-top: .5333333rem;
    .van-icon-close{
      font-size: .96rem;
      color: #f4d280;
    }
  }
}
.applyBtn{
    width: 100%;
    padding: .6rem 0 0;
    // background: #fff;
    border-bottom-left-radius: .2rem;
    border-bottom-right-radius: .2rem;
   
    .btnbar{
      width: .156rem;
      height: 1.1rem;
      border-radius: .26rem;
    }

    .btndiv{
      display: flex;
      width: 58%;
      height: 1.28rem;
      line-height: 1.28rem;
      background: url('@/assets/newmediatemp/titlebg.png') no-repeat;
      background-size: 100% 100%;
      color: #f4d280;
      font-size: 0.4rem;
      font-weight: bold;
      text-align: center;
      letter-spacing: 0.1em;
      margin: 0 3px;
    }

  }
</style>